export const betTypesRtpFormulas = {
  Blue: 13 / 27,
  Red: 17 / 54,
  Green: 5 / 27,
  Yellow: 1 / 54,
};
